export default __webpack_public_path__ + "static/media/promo-vip-banner.b907eb0d.webp";